var _style, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryAnimals = function SvgCategoryAnimals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_animals_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_animals_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_animals_svg__st0",
    d: "M24.4 36.6c.2.2 2.9 2.1 5.6.9.3-.2 1.7-.7 2.3-2.1 1-2.2-.5-4.7-1.3-6-2-3.2-5.1-4.8-6.9-5.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_animals_svg__st0",
    d: "M24 36.6c-.2.2-2.9 2.1-5.6.9-.3-.2-1.7-.7-2.3-2.1-1-2.2.5-4.7 1.3-6 2-3.2 5.1-4.8 6.9-5.6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-13.32 19.613 15.815)",
    className: "category_animals_svg__st0",
    cx: 19.6,
    cy: 15.8,
    rx: 2.9,
    ry: 4.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-13.32 12.987 23.694)",
    className: "category_animals_svg__st0",
    cx: 13,
    cy: 23.7,
    rx: 2.6,
    ry: 3.9
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-76.679 28.414 15.61)",
    className: "category_animals_svg__st0",
    cx: 28.4,
    cy: 15.6,
    rx: 4.6,
    ry: 2.9
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-76.679 35.025 23.501)",
    className: "category_animals_svg__st0",
    cx: 35,
    cy: 23.5,
    rx: 3.9,
    ry: 2.6
  })));
};
export default SvgCategoryAnimals;